import { FlexRow, MaterialIcon, useLoading } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';
import { useRecoilValue } from 'recoil';
import { useFeedback } from '../../../hooks/useFeedback';
import { useStyles } from '../../../hooks/useStyles';
import { requestPathsReportFile } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import { assetState } from '../../../storage/assets';
import {
  pathDistanceFilterState,
  pathTimeFilterState,
  reportEndDateState,
  reportStartDateState,
} from '../../../storage/reports';
import { getAssetTitle } from '../../../utils/assets';
import { StyledTooltip } from '../../ui/StyledTooltip';

type Props = {
  assetId: string;
};

function PathItemTitle({ assetId }: Props) {
  const { theme, css, classes } = useStyles();
  const asset = useRecoilValue(assetState(assetId));
  const endDate = useRecoilValue(reportEndDateState);
  const startDate = useRecoilValue(reportStartDateState);
  const apiParams = useRecoilValue(apiParamsState);
  const { showPositiveFeedback, showFailFeedback } = useFeedback();
  const { loading, startLoading, stopLoading } = useLoading();
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const pathTimeFilter = useRecoilValue(pathTimeFilterState);
  const pathDistanceFilter = useRecoilValue(pathDistanceFilterState);

  const createReport = async (assetId: string) => {
    if (!apiParams || !startDate || !endDate) return;
    startLoading();
    const { error } = await requestPathsReportFile(
      assetId,
      startDate,
      endDate,
      apiParams.clientId,
      isAllWorkspacesSelected ? undefined : apiParams.subClientId,
      {
        minSeconds: pathTimeFilter * 60 || 300,
        minMeters: pathDistanceFilter || 700,
      },
    );
    if (!error) {
      showPositiveFeedback('Tu reporte será procesado, visita la sección de descargas para obtenerlo.');
    } else if (error) {
      showFailFeedback(`${error}`);
    }
    stopLoading();
  };

  if (!asset) return null;

  return (
    <FlexRow
      classNames={css({
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      })}
    >
      <FlexRow
        gap={theme.sizing.scale200}
        classNames={classes.centeredStart}
      >
        <LabelMedium>{getAssetTitle(asset)}</LabelMedium>
        <ParagraphSmall
          margin={0}
          color={theme.colors.contentSecondary}
        >
          ({asset.label})
        </ParagraphSmall>
      </FlexRow>
      <StyledTooltip
        content="Descargar por activo"
        showArrow={false}
        placement="top"
        ignoreBoundary
      >
        <Button
          size="mini"
          shape="circle"
          kind="tertiary"
          isLoading={loading}
          onClick={(e) => {
            e.stopPropagation();
            createReport(assetId);
          }}
        >
          <MaterialIcon
            name="download"
            size="mini"
          />
        </Button>
      </StyledTooltip>
    </FlexRow>
  );
}

export default PathItemTitle;
